import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import CheckboxInput, { CheckboxInputProps } from '@/components/ui/inputs/CheckboxInput'

type CheckboxFieldProps = FieldHookConfig<boolean> & CheckboxInputProps

const MemoizedCheckboxInput = React.memo<CheckboxInputProps>(CheckboxInput)

export default function CheckboxField(props: CheckboxFieldProps) {
  const [field] = useField<boolean>({ name: props.name, type: 'checkbox', value: props.value })

  return (
    <MemoizedCheckboxInput
      {...props}
      checked={field.checked}
      onChange={field.onChange}
    />
  )
}